import classNames from 'classnames'

import { Favorite } from 'modules/territory'

import type { IFavoriteTerritoryCellView } from './favorite-territory-cell.types'

import './favorite-territory-cell.styles.scss'

export const FavoriteTerritoryCellView = (props: IFavoriteTerritoryCellView) => {
  return (
    <div className={classNames(['FavoriteTerritoryCell', { isActive: props?.isFollowed }])}>
      <Favorite
        initialSaveState={props?.isFollowed}
        territoryId={props?.territoryId}
        territoryName={props?.name}
        territoryType={props?.entityType}
        size="sm"
      />
    </div>
  )
}
